import { useCallback, useEffect, useState } from "react";
import API from "../../../../Api/Api";

export const useTransporter = () => {
  const [loading, setLoading] = useState(false);
  const [transporterOptions, setTransporterOptions] = useState([]);

  const getTransporterOptions = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await API.get("/api/transporters", {
        params: {
          sort: "name:asc",
        },
      });
      setTransporterOptions(
        data?.data?.map((item) => ({
          name: item?.attributes?.name,
          code: item?.id,
        }))
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getTransporterOptions();
  }, [getTransporterOptions]);

  return { loading, transporterOptions };
};
